import LinkButton from "../General/LinkButton";
import {ReactComponent as ChatOnWhatsApp} from "../Icons/WhatsAppButtonGreenLarge.svg";

const SiteBanner = () => {
  return <div className="flex h-screen bg-my-orange text-white px-4 md:px-0">
    <div className="m-auto text-center max-w-screen-sm">
      <h1 className="h-52 m-3 bg-nav-logo-white bg-no-repeat bg-center bg-contain">
        <span className="invisible">
          Flossi Pay
        </span>
      </h1>

      <h2 className="mx-auto text-l py-3">
        We're currently undergoing maintenance and will be back as soon as possible
      </h2>

      <h2 className="mx-auto text-l py-3">
        If your query is urgent, please contact us via the following methods:
      </h2>

      <a href="https://wa.me/+447822013827">
        <ChatOnWhatsApp className="text-center mx-auto" />
      </a>
      <span className="block">
        Or
      </span>
      <LinkButton type="link" backgroundColour="my-olive" url="mailto:support@flossipay.com">Send us an email</LinkButton>
    </div>
  </div>
}

export default SiteBanner